import SessionEventProto from "../session-event-proto";


export default class SessionEvent_TeamReset extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {

        gd.session.teams.resetFromJson(this.data)
    }
}; 